import React from 'react';
import { Box, Container, Paper, Typography, Skeleton, Divider } from '@mui/material';

const PaymentSkeleton: React.FC = () => (
  <Box sx={{ minHeight: '100vh', width: '100vw', background: '#f5f5f5', py: 4 }}>
    <Container maxWidth="sm" sx={{ pb: { xs: 10, sm: 4 } }}>
      {/* Header Skeleton */}
      <Box sx={{ mt: 4, mb: 3, textAlign: 'center' }}>
        <Skeleton variant="text" width="70%" height={40} sx={{ mx: 'auto', mb: 1 }} />
        <Skeleton variant="text" width="50%" height={24} sx={{ mx: 'auto' }} />
      </Box>
      
      {/* Order Summary Card Skeleton */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: 2 }}>
        <Typography variant="h6" gutterBottom>
          Order Summary
        </Typography>
        
        {/* Order Items Skeleton */}
        {[1, 2, 3].map((item) => (
          <Box key={item} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="40%" height={16} />
            </Box>
            <Skeleton variant="text" width="15%" height={20} />
          </Box>
        ))}
        
        <Divider sx={{ my: 2 }} />
        
        {/* Total Section Skeleton */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Skeleton variant="text" width="30%" height={20} />
          <Skeleton variant="text" width="20%" height={20} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Skeleton variant="text" width="25%" height={20} />
          <Skeleton variant="text" width="20%" height={20} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="text" width="25%" height={24} />
        </Box>
        
        {/* Pay Button Skeleton */}
        <Skeleton variant="rounded" width="100%" height={48} sx={{ borderRadius: 2 }} />
      </Paper>
    </Container>
  </Box>
);

export default PaymentSkeleton; 